module.exports = __webpack_public_path__ + "assets/img/官网首页_04.b0e4d568.jpg";